import { Link } from "react-router-dom";
import "../../styles/features/events/Events.css";

export default function Events() {
 return (
    <section className="event-types bg-gradient">
      {/* fala */}
      <img
        src="/images/wave.svg"
        alt=""
        className="wave-deco wave-top"
        aria-hidden="true"
      />

      <div className="types-grid">
        {/* KAFEL 1 — Imprezy dla singli */}
        <div className="type-wrap type-party">
          {/* ozdoby dookoła */}
          <span className="blob blob-a" aria-hidden="true" />
          <span className="dot dot-1" aria-hidden="true" />
          <span className="dot dot-2" aria-hidden="true" />

          <Link
            to="/events/party"               
            className="type-card"
            aria-label="Imprezy dla singli"
          >
            <img
              src="/images/single.jpg"       
              alt="Imprezy dla singli"
              className="type-img"
              loading="eager"
            />
            <div className="type-gradient" />
            <div className="type-title">Spotkania</div>
          </Link>
        </div>

        {/* KAFEL 2 — Warsztaty dla kobiet */}
        <div className="type-wrap type-workshop">
          {/* ozdoby dookoła */}
          <span className="blob blob-b" aria-hidden="true" />
          <span className="dot dot-3" aria-hidden="true" />
          <span className="dot dot-4" aria-hidden="true" />

          <Link
            to="/events/girlsmeetings"            
            className="type-card"
            aria-label="Warsztaty dla kobiet"
          >
            <img
              src="/images/workshop.jpg"     
              alt="Warsztaty dla kobiet"
              className="type-img"
              loading="eager"
            />
            <div className="type-gradient" />
            <div className="type-title">Spotkania dla kobiet</div>
          </Link>
        </div>
      </div>
    </section>
  );
}